import { useContext, useMemo } from 'react';
import { isEmpty } from 'lodash-es';
import cls from 'clsx';
import { Hide } from '@s20/components/common/Hide';
import { getShort } from '@s20/common/util/date';
import { FormContext, SmallOutlineButton } from '../../../common/forms/FormElements';
import { AccordionCollapse } from '../../../common/AccordionCollapse';
import { Job } from './Job';

// Stable identity so the memo below is not invalidated on every render.
const NO_JOB = {};

// The map can show several days at once, so the collapsed card has to name its day.
const jobTitle = (job) => (
    <>
        <div>{[job.jobNumber, job.customer].filter(Boolean).join(' – ')}</div>

        <div className="small font-weight-normal text-muted">
            {getShort(job.assignmentDate)}
        </div>
    </>
);

export const InfoPane = () => {
    const { values, setFieldValue } = useContext(FormContext);
    const { jobGroup } = values;

    // Cleared as null, not undefined, so a destructuring default would not catch it.
    const selectedJob = values.selectedJob || NO_JOB;

    const renderJobs = useMemo(() => isEmpty(jobGroup) && !isEmpty(selectedJob) ? (
        <AccordionCollapse
            key={`info-job-${selectedJob.jobId}`}
            title={jobTitle(selectedJob)}
            defaultOpen
        >
            <Job {...selectedJob} />
        </AccordionCollapse>
    ) : jobGroup?.map((job, index) => (
        <AccordionCollapse
            key={`info-job-${job.jobId}-${job.assignmentDate}`}
            title={jobTitle(job)}
            defaultOpen={jobGroup.length === 1 || index === 0}
            secondaryAction={(
                <SmallOutlineButton
                    onClick={() => setFieldValue('selectedJob', job)}
                    disabled={selectedJob.jobId === job.jobId}
                >
                    {selectedJob.jobId === job.jobId ? 'Selected' : 'Select'}
                </SmallOutlineButton>
            )}
        >
            <Job {...job} />
        </AccordionCollapse>
    )), [jobGroup, selectedJob, setFieldValue]);

    return (
        <>
            <Hide mdUp>
                <div className={cls('ml-2 map-information-pane customer-portal-pane', (!isEmpty(selectedJob) || !isEmpty(jobGroup)) && 'show')}>
                    {renderJobs}
                </div>
            </Hide>

            <Hide smDown>
                {renderJobs}
            </Hide>
        </>
    );
};